/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentDto } from '../../models/amoxcalli-student-dto';

export interface ApiStudentsGet$Plain$Params {
  groupId?: string;
}

export function apiStudentsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiStudentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliStudentDto>>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliStudentDto>>;
    })
  );
}

apiStudentsGet$Plain.PATH = '/api/students';
